import { createFormHook, createFormHookContexts } from '@tanstack/react-form';
import { MainTabs } from '../pages/contests/ContestPage/MainTabs';

// export useFieldContext for use in your custom components
export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  // We'll learn more about these options later
  fieldComponents: {},
  formComponents: {
    MainTabs,
  },
});

export const useGameForm = useAppForm;
